import React from "react";
import { BottomMenuButton } from "../../bottom-menu/bottom-menu-button";
import { BottomMenuButtons, IBottomMenuButton } from "../../bottom-menu/buttons";

export const BottomBackgroundMenu = ({
	menuItems,
	activeButtonId,
	showBackButton,
	onBack,
}: {
	/** As argument so they can be prefetched */
	menuItems: readonly Omit<IBottomMenuButton, "isActive">[];
	activeButtonId: string;
	showBackButton: boolean;
	onBack: () => void;
}) => {
	return (
		<BottomMenuButtons showBackButton={showBackButton} onBack={onBack}>
			{menuItems.map(({ iconName, id, ...props }) => {
				return (
					<BottomMenuButton
						{...props}
						key={id}
						iconName={iconName}
						isActive={activeButtonId === id}
					/>
				);
			})}
		</BottomMenuButtons>
	);
};
BottomBackgroundMenu.displayName = "BottomBackgroundMenu";
